<template>
  <v-dialog v-model="dialog" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn :color="buttonColor" icon v-bind="attrs" v-on="on" @click="openClicked">
        <span v-if="item.id === undefined">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-plus</v-icon>
            </template>
            <span>{{ $t('add') }}</span>
          </v-tooltip>
        </span>
        <span v-if="item.id !== undefined">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-circle-edit-outline</v-icon>
            </template>
            <span>{{ $t('edit') }}</span>
          </v-tooltip>
        </span>
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-form v-model="valid" ref="form">
                <v-text-field
                  v-model="item.infoNm"
                  :label="label.info"
                  :rules="[validator.required, validator.maxLength(100)]"
                  counter="100"
                  outlined
                  dense
                  clearable
                />
                <Calendar
                  v-model="item.startDatetime"
                  :label="label.from"
                  :rules="[validator.required, validator.isAfterDate(item.endDatetime)]"
                  clearable
                />
                <Calendar
                  v-model="item.endDatetime"
                  :label="label.to"
                  :rules="[validator.required, validator.isBeforeDate(item.startDatetime)]"
                  clearable
                />
                <div v-if="item.infoFile">
                  <v-checkbox
                    v-model="item.isInfoFileDelete"
                    class="d-inline-block"
                    :label="label.deleteAttachments"
                  ></v-checkbox>
                  <v-btn @click="downloadInfoFile(item)" color="primary" dark small class="ml-5">{{
                    label.attachedFile
                  }}</v-btn>
                </div>
                <v-file-input
                  v-if="!item.isInfoFileDelete"
                  v-model="item.infoFileLocal"
                  :label="label.attachedFile"
                  :rules="[validator.isPDF, validator.maxBytes(10)]"
                  outlined
                  dense
                  show-size
                  chips
                  clearable
                  prepend-inner-icon="mdi-paperclip"
                  prepend-icon=""
                ></v-file-input>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" color="secondary" text>
          {{ $t('cancel') }}
        </v-btn>
        <v-btn @click="submit" color="primary" text>
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import validator from '@/utils/validator.js';
  import Calendar from '../components/Calendar.vue';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      Calendar,
    },
    mixins: [validator],
    data: () => ({
      valid: false,
      dialog: false,
      displayFromMenu: false,
      displayToMenu: false,
      item: {
        id: undefined,
        infoNm: '',
        startDatetime: '',
        endDatetime: '',
        infoFileLocal: null,
        isInfoFileDelete: false,
      },
    }),
    computed: {
      ...mapGetters('auth', ['access_token', 'user_info']),
      buttonColor() {
        return this.item.id ? 'green' : 'blue';
      },
      label() {
        return {
          info: this.$t('notifications'),
          from: `${this.$t('from')}(UTC)`,
          to: `${this.$t('to')}(UTC)`,
          attachedFile: this.$t('attachedFile'),
          deleteAttachments: this.$t('deleteAttachments'),
        };
      },
    },
    props: {
      value: null,
    },
    created() {
      if (this.$props.value !== undefined) {
        // 一覧とは同期させないので値渡し
        this.item = Object.assign({}, this.$props.value);
      }
    },
    methods: {
      async openClicked() {
        if (this.item.id !== undefined) {
          this.$store.commit('loading/start_loading');
          console.info('Azure API開始');
          try {
            // 再取得
            const info = await this.azureRequest(
              '/api/getInformation?code=/euBFfLP8HKSR4bzlePZpGFaPvR0DZoKWRpir9pBJpZkatlHtKWzug==',
              'GET',
              {
                id: this.$props.value.id,
              }
            );
            console.dir(info);
            info.isInfoFileDelete = false;

            info.startDatetime = this.$moment(info.startDatetime).format('YYYY-MM-DD');
            info.endDatetime = this.$moment(info.endDatetime).format('YYYY-MM-DD');
            this.item = info;
          } catch (error) {
            console.error(error);
          } finally {
            console.info('Azure API完了');
            this.$store.commit('loading/end_loading');
          }
        } else {
          this.item = { id: undefined, infoNm: '', startDatetime: '', endDatetime: '', infoFileLocal: null };
        }
      },
      fileToBase64() {
        return new Promise((resolve, reject) => {
          const fileObject = this.item.infoFileLocal;
          if (!fileObject) {
            resolve(null);
          } else {
            const reader = new FileReader();
            reader.readAsDataURL(fileObject);
            reader.onload = () => {
              const base64 = reader.result.split(';base64,')[1];
              resolve(base64);
            };
            reader.onError = () => {
              // ファイル読み込みエラー
              reject();
            };
          }
        });
      },
      async submit() {
        // バリデーション
        if (!this.$refs.form.validate()) {
          return;
        }

        // ここで保存
        const userId = this.user_info.userId;

        const startDate = this.$moment(this.item.startDatetime).startOf('day').format('YYYY-MM-DD HH:mm:ss.SSSSSSS');
        const endDate = this.$moment(this.item.endDatetime).endOf('day').format('YYYY-MM-DD HH:mm:ss.SSSSSSS');

        const params = {
          id: this.item.id ? this.item.id : this.$uuid.v4(),
          infoNm: this.item.infoNm,
          startDatetime: startDate,
          endDatetime: endDate,
          infoFile: '',
          isInfoFileDelete: this.item.isInfoFileDelete,
          _ts: this.item._ts,
          user: userId,
        };
        const base64 = await this.fileToBase64();

        if (base64) {
          params.infoFile = this.item.infoFile ? this.item.infoFile : this.$uuid.v4();
          params.infoFileBase64 = base64;
        }

        this.$store.commit('loading/start_loading');
        console.info('Azure API開始');
        try {
          if (!this.item.id) {
            const info = await this.azureRequest('/api/addInformation', 'POST', params);
            console.dir(info);
          } else {
            const info = await this.azureRequest('/api/putInformation', 'PUT', params);
            console.dir(info);
          }
        } catch (error) {
          console.error(error);
        } finally {
          console.info('Azure API完了');
          this.$store.commit('loading/end_loading');
        }
        this.$emit('persist');

        this.dialog = false;
      },
      async downloadInfoFile(item) {
        console.info('Azure API開始');
        try {
          const file = await this.azureRequest('/api/getInformationFiles', 'GET_BLOB', {
            id: item.id,
            infoFile: item.infoFile,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(file);
          // ファイル名の生成
          link.download = `${item.infoFile}.pdf`;
          link.click();
        } catch (error) {
          console.error(error);
        } finally {
          console.info('Azure API完了');
        }
      },
    },
  };
</script>
